import { render, staticRenderFns } from "./DoaAgingReport.vue?vue&type=template&id=18c477ae&scoped=true&"
import script from "./DoaAgingReport.vue?vue&type=script&lang=js&"
export * from "./DoaAgingReport.vue?vue&type=script&lang=js&"
import style0 from "./DoaAgingReport.vue?vue&type=style&index=0&id=18c477ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c477ae",
  null
  
)

export default component.exports